
<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [buildParams]="buildParams"
  [tableParams]="tableParams"
  [viewRoute]="'challenges'"
>
</app-ag-grid-table>
